import type { ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";
import { type FnContext as FnContext, type SectionProps as SectionProps } from "~/types/deco";
export interface IImage {
    src: ImageWidget;
    alt?: string;
    width: number;
    height: number;
}
interface BackgroundImage {
    desktop?: ImageWidget;
    /**
     * @title Sobreposição de cor (desktop)
     */
    colorOverlayDesktop?: boolean;
    mobile?: ImageWidget;
    /**
     * @title Sobreposição de cor (mobile)
     */
    colorOverlayMobile?: boolean;
}
export interface Catalogs {
    /**
     * @title Imagens
     */
    images: IImage[];
    /**
     * @title Texto alternativo das images
     */
    alt?: string;
    /**
     * @title Titulo
     */
    title?: string;
    /**
     * @title Description
     * @format html
     */
    description?: string;
    /**
     * @title Link
     */
    link?: string;
    /**
     * @title Nome do link
     */
    button?: string;
}
export interface Props {
    /**
     * @title Titulo
     */
    title: string;
    /**
     * @title Subtítulo
     */
    subtitle?: string;
    /**
     * @title Descrição
     * @format html
     */
    description?: string;
    /**
     * @title Catálogos
     */
    catalogs?: Catalogs;
    /**
     * @title Imagem de fundo
     */
    backgroundImage?: BackgroundImage;
    /**
     * @title GIF de scroll
     */
    gif?: ImageWidget;
}
export default function Hero({ title, subtitle, description, backgroundImage, catalogs, gif, isMobileDevice, }: SectionProps<typeof loader>) {
    return (<div className='bg-[#ff8a3d] bg-no-repeat bg-cover bg-center lg:bg-[60%_25%]' style={{
            backgroundImage: `url(${isMobileDevice ? backgroundImage?.mobile : backgroundImage?.desktop})`,
        }}>
            <div className={`py-4 ${(backgroundImage?.colorOverlayDesktop && !isMobileDevice) ||
            (backgroundImage?.colorOverlayMobile && isMobileDevice)
            ? 'bg-[#ff8a3d] bg-opacity-50'
            : ''}`}>
                <div className='max-w-[960px] px-2 mx-auto font-lato grid items-center gap-8 lg:px-0 lg:grid-cols-2 lg:relative'>
                    <div className='max-w-[480px] mx-auto text-center lg:text-left'>
                        <h1 className='text-white text-[36px] leading-snug font-black resale-lingerie-scale-animation lg:text-[46px]'>
                            {title}
                        </h1>

                        {subtitle && (<h2 className='mt-2 text-white text-[22px] leading-6 resale-lingerie-scale-animation lg:mt-6'>
                                {subtitle}
                            </h2>)}

                        {isMobileDevice && catalogs?.images[0] && (<Image className='mt-8 mx-auto' src={catalogs.images[0].src} alt={catalogs.alt} width={catalogs.images[0].width} height={catalogs.images[0].height} loading='lazy'/>)}

                        {description && (<div className='mt-14 text-white text-[19px] leading-[26px]' dangerouslySetInnerHTML={{ __html: description }}/>)}
                    </div>

                    {gif && (<img className='mx-auto lg:absolute lg:bottom-0 lg:left-1/2 lg:-translate-x-1/2' src={gif} alt='Role a página' width={22} height={33} loading='lazy'/>)}

                    <div className='flex flex-col-reverse justify-center lg:flex-col'>
                        {isMobileDevice && catalogs?.images[1]
            ? (<Image className='w-full max-w-[390px] mx-auto object-contain' src={catalogs.images[1].src} alt={catalogs.images[1].alt} width={catalogs.images[1].width} height={catalogs.images[1].height} loading='lazy'/>)
            : (<div className='relative' style={{ marginBottom: (catalogs?.images.length ?? 0) * 20 }}>
                                    {catalogs?.images.map((image, index) => (<Image className='max-w-[390px] object-contain' style={{
                        position: index > 0 ? 'absolute' : 'relative',
                        top: index * 10,
                        left: index * 80,
                    }} src={image.src} alt={catalogs.alt} width={image.width} height={image.height} loading='lazy'/>))}
                                </div>)}

                        <div className='grid justify-items-center gap-4'>
                            {catalogs?.title && (<h2 className='text-white text-[27px] text-center font-black'>
                                    {catalogs.title}
                                </h2>)}

                            {catalogs?.description && (<div className='text-white text-lg text-center leading-6' dangerouslySetInnerHTML={{ __html: catalogs.description }}/>)}

                            {catalogs?.link && (<a className='w-max px-16 py-3.5 rounded-full bg-[#8A1538] text-[#ff8a3d] text-lg text-center font-black block transition-colors duration-300 resale-lingerie-shake-animation hover:text-white' href={catalogs.link} target='_blank' rel='noreferrer'>
                                    {catalogs.button}
                                </a>)}
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
export const loader = (props: Props, _: Request, ctx: FnContext) => {
    const isMobileDevice = ctx.device !== 'desktop';
    return {
        ...props,
        isMobileDevice,
    };
};
